import { apiSlice } from './apiSlice';
import { TRANSFERS_URL } from '../constants';

export const transfersApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // Create a new transfer
    createTransfer: builder.mutation({
      query: (transfer) => ({
        url: TRANSFERS_URL,
        method: 'POST',
        body: transfer,
      }),
    }),

    // Get transfer details by ID
    getTransferDetails: builder.query({
      query: (id) => ({
        url: `${TRANSFERS_URL}/${id}`,
      }),
      keepUnusedDataFor: 5,
    }),

    // Get logged-in user's transfers
    getMyTransfers: builder.query({
      query: () => ({
        url: `${TRANSFERS_URL}/mine`,
      }),
      keepUnusedDataFor: 5,
    }),

    // Get all transfers (Admin)
    getTransfers: builder.query({
      query: () => ({
        url: TRANSFERS_URL,
      }),
      keepUnusedDataFor: 5,
    }),

    // Mark transfer as delivered
    deliverTransfer: builder.mutation({
      query: (transferId) => ({
        url: `${TRANSFERS_URL}/${transferId}/deliver`,
        method: 'PUT',
      }),
    }),

    // Delete transfer
    deleteTransfer: builder.mutation({
      query: (transferId) => ({
        url: `${TRANSFERS_URL}/${transferId}`,
        method: 'DELETE',
      }),
    }),

    // Delete specific transfer items
    deleteTransferItems: builder.mutation({
      query: ({ transferId, transferItemsIndexes }) => ({
        url: `${TRANSFERS_URL}/${transferId}/delete-items`,
        method: 'PUT',
        body: { transferItemsIndexes },
      }),
    }),

    // Update transfer
    updateTransfer: builder.mutation({
      query: ({ transferId, ...body }) => ({
        url: `${TRANSFERS_URL}/${transferId}`,
        method: 'PUT',
        body,
      }),
    }),

    // ⭐ Fix missing product IDs (admin)
    fixMissingProductIds: builder.mutation({
      query: () => ({
        url: `${TRANSFERS_URL}/fix-missing-ids`,
        method: 'PUT',
      }),
    }),

    // ⭐ Repair ALL transfers (admin)
    repairAllTransfers: builder.mutation({
      query: () => ({
        url: `${TRANSFERS_URL}/repair-all`,
        method: 'PUT',
      }),
    }),

    /* -----------------------------------------------------------
       ⭐ NEW — GLOBAL IMAGE UPLOAD (NO transferId REQUIRED)
       Upload images BEFORE transfer creation
    ----------------------------------------------------------- */
    uploadTransferImages: builder.mutation({
      query: (formData) => ({
        url: `${TRANSFERS_URL}/upload-images`,
        method: 'POST',
        body: formData, // MUST be FormData
      }),
    }),
  }),
});

export const {
  useCreateTransferMutation,
  useGetTransferDetailsQuery,
  useGetMyTransfersQuery,
  useGetTransfersQuery,
  useDeliverTransferMutation,
  useDeleteTransferMutation,
  useDeleteTransferItemsMutation,
  useUpdateTransferMutation,
  useFixMissingProductIdsMutation,
  useRepairAllTransfersMutation,

  // ⭐ NEW
  useUploadTransferImagesMutation,
} = transfersApiSlice;
